import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import type {
  ReengagementSettings,
  UpdateReengagementSettingsInput,
} from "@school-sales-ai/shared";
import { api } from "@/lib/api";
import { useScopedClientId } from "@/hooks/useScopedClientId";

const BASE = "/crm/reengagement/settings";

/** «Mensajes de seguimiento» — readable by every role, writable by admins. */
export function useReengagementSettings() {
  const clientId = useScopedClientId();
  return useQuery({
    queryKey: ["reengagement-settings", clientId],
    queryFn: () => api.get<ReengagementSettings>(BASE),
    enabled: !!clientId,
  });
}

export function useUpdateReengagementSettings() {
  const queryClient = useQueryClient();
  const clientId = useScopedClientId();
  return useMutation({
    mutationFn: (patch: UpdateReengagementSettingsInput) =>
      api.put<ReengagementSettings>(BASE, patch),
    onSuccess: (data) => {
      queryClient.setQueryData(["reengagement-settings", clientId], data);
      toast.success("Mensajes de seguimiento guardados.");
    },
    onError: (err: Error) => toast.error(err.message),
  });
}
